import React, { useState } from 'react';
import {
    Box,
    TextField,
    Button,
    Typography,
    Paper,
    CircularProgress,
} from '@mui/material';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import apiUrl from '../Config';

const Login = ({ onLogin }) => {
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.email || !formData.password) {
            setError('Email and Password are required');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const response = await axios.post(`${apiUrl}/adminuser/login`, {
                email: formData.email,
                password: formData.password,
            });

            const { token, status, message } = response.data;

            if (status && token) {
                sessionStorage.setItem('token', token);
                toast.success('Login successful!');
                onLogin(); // Callback to parent if needed
            } else {
                setError(message || 'Invalid credentials');
            }
        } catch (err) {
            console.log(err, "err in login")
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
            bgcolor="#f4f6f8"
        >
            <Paper elevation={3} sx={{ p: 4, width: 350 }}>
                <Typography variant="h5" mb={3} textAlign="center">
                    Login
                </Typography>
                <form onSubmit={handleSubmit}>
                    <TextField
                        label="Email"
                        name="email"
                        type="email"
                        fullWidth
                        size="small"
                        margin="normal"
                        value={formData.email}
                        onChange={handleChange}
                        error={Boolean(error && !formData.email)}
                    />
                    <TextField
                        label="Password"
                        name="password"
                        type="password"
                        fullWidth
                        size="small"
                        margin="normal"
                        value={formData.password}
                        onChange={handleChange}
                        error={Boolean(error && !formData.password)}
                    />

                    {error && (
                        <Typography color="error" mt={1} fontSize="0.9rem">
                            {error}
                        </Typography>
                    )}

                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        sx={{ mt: 2 }}
                        disabled={loading}
                    >
                        {loading ? <CircularProgress size={24} sx={{ color: 'white' }} /> : 'Login'}
                    </Button>
                </form>
            </Paper>
        </Box>
    );
};

export default Login;
